<template> 
  <div class="OrderEvaluate">
    <el-dialog :visible="showRate" width="30%" :lock-scroll="true" :center="true" @close="closeRate">
      <strong class="red">评价</strong>
      <div v-if="orderInfo.orderType === 9">
        <el-card class="food-card" v-for="(item, index) in orderInfo.orderServiceList" :key="index">
          <el-row>
            <el-col :span="14">
              <div class="food-info">
                <img class="food-img" :src="item.picUrl+'?imageView2/1/w/134/h/100'" alt="">
                <p class="title ellipse2">{{ item.title }}</p>
              </div>
            </el-col>
            <el-col :span="10">
              <div class="food-rate">
                <el-rate v-model="scoreList[index]" :texts="rateText" show-text :colors="['#d0011b', '#d0011b', '#d0011b']" disabled-void-color="#aaa"></el-rate>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
      <div class="other-rate" v-else>
        <el-rate v-model="score" :texts="rateText" show-text :colors="['#d0011b', '#d0011b', '#d0011b']" disabled-void-color="#aaa"></el-rate>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="postEvaluate" :loading="loading">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    showRate: {
      type: Boolean,
      required: true
    },
    orderInfo: {
      type: Object,
      default() {
        return{}
      },
    },
  },
  data() {
    return {
      rateText:['非常不满意','不满意','一般','比较满意','非常满意',],
      score: 0,
      scoreList:[],
      loading: false,
    }
  },
  methods:{
    closeRate(){
      this.$emit('closeRate', true);
    },
    postEvaluate() {
      let params = {
        orderId: this.orderInfo.orderId
      }
      if(this.orderInfo.orderType === 9){
        let foodScore = [];
        this.orderInfo.orderServiceList.map((item, index) => {
          if(this.scoreList[index]>0){
            foodScore.push({foodId:item.foodId, score:this.scoreList[index]});
          }
        })
        if(foodScore.length < this.orderInfo.orderServiceList.length){
          this.$message.error('请评价各个商品');
          return;
        }
        params.foodScore = foodScore;
      }else{
        if(!this.score){
          this.$message.error('请选择满意度');
          return;
        }
        params.score = this.score;
      }

      //提交评价
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/score/user/order/info`, params, {
        headers: { token: this.token },
      }).then((res) => {
        this.loading = false;
        if(res.data.resCode === '10000') {
          this.$message.success('提交成功');
          this.$emit('closeRate', true, true);
        }else{
          this.$message.error(res.data.resDesc);
        }
      });
    },
  },
  computed: {
    ...mapGetters(['token']),
  },
};
</script>

<style lang="scss" scoped>
.food-card{
  margin-top: 5px;
  width: 100%;
}
.red{
  color: red;
}
.food-info{
  vertical-align: middle;
  .food-img{
    width: 134px;
    height: 100px;
  }
  .title{
    padding-left: 30px;
    font-size: 12px;
    color: #666;
  }
}
.food-rate{
  padding-top: 30px;
}
.other-rate{
  padding-top: 10px;
  padding-left: 36%;
}
</style>



// WEBPACK FOOTER //
// src/components/orderDetails/OrderEvaluate.vue